module.exports = __webpack_public_path__ + "img/play-button.db6e5cf9.png";